/**
 * Phần thuần của tab "Biến & tham số" (`workflow-values.ts` của web-portal native): kiểm giá trị theo kiểu như máy
 * chủ, tính danh sách đã đổi, lọc và sắp.
 */
import type { MucGiaTri } from '../types.ts';

export type LocLoaiGiaTri = '' | 'argument' | 'variable';
export type LoiGiaTri = 'boolean' | 'integer' | 'number';

export interface BoLocGiaTri {
  tim: string;
  loai: LocLoaiGiaTri;
  /** Chỉ hiện tham số và biến đang có giá trị (ẩn biến làm việc trống). Tham số luôn hiện. */
  chiCoGiaTri: boolean;
}

export const BO_LOC_MAC_DINH: BoLocGiaTri = { tim: '', loai: '', chiCoGiaTri: true };

/** Giá trị đang nhập theo `key`; vắng = chưa sửa. */
export type BanNhapGiaTri = Record<string, string>;

const DUNG_SAI = /^(true|false)$/i;
const SO_NGUYEN = /^-?\d+$/;
const SO = /^-?\d+(\.\d+)?$/;

/** Trống luôn hợp lệ (= bỏ giá trị mặc định). */
export function loiGiaTri(muc: MucGiaTri, giaTri: string): LoiGiaTri | null {
  const s = giaTri.trim();
  if (!s || muc.valueType === 'string' || muc.valueType === '') return null;
  if (muc.valueType === 'boolean') return DUNG_SAI.test(s) ? null : 'boolean';
  if (muc.valueType === 'integer') return SO_NGUYEN.test(s) ? null : 'integer';
  return SO.test(s) ? null : 'number';
}

/** Mục đã đổi so với máy chủ. Mục bí mật chỉ tính khi đã nhập giá trị mới (để trống = giữ nguyên). */
export function mucDaDoi(items: readonly MucGiaTri[], banNhap: BanNhapGiaTri): { muc: MucGiaTri; giaTri: string }[] {
  return items.flatMap((muc) => {
    const giaTri = banNhap[muc.key];
    if (giaTri === undefined || !muc.editable) return [];
    if (muc.secret ? giaTri === '' : giaTri === muc.value) return [];
    return [{ muc, giaTri }];
  });
}

export function coLoiGiaTri(items: readonly MucGiaTri[], banNhap: BanNhapGiaTri): boolean {
  return mucDaDoi(items, banNhap).some(({ muc, giaTri }) => loiGiaTri(muc, giaTri) !== null);
}

/** Tham số trước, rồi biến theo thứ tự trong Workflow. */
export function locGiaTri(items: readonly MucGiaTri[], loc: BoLocGiaTri): MucGiaTri[] {
  const q = loc.tim.trim().toLowerCase();
  return items
    .filter((i) => !loc.loai || i.kind === loc.loai)
    .filter((i) => !loc.chiCoGiaTri || i.kind === 'argument' || i.hasValue)
    .filter((i) => !q || [i.name, i.scope, i.type].some((v) => v.toLowerCase().includes(q)))
    .sort((a, b) => Number(a.kind === 'variable') - Number(b.kind === 'variable'));
}
